import { useQuery, useMutation } from "react-query";
import { useTranslation } from "react-i18next";
import { App } from "antd";

import * as api from "apis/attendanceLog";

export function useAttendanceLogs({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["attendancesLog", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendanceLogs(payload);
        response = data;
      } catch (error) {
        throw new Error(t("error.failed_to_load_data_from_server"));
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useAttendanceLogsApproval({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["attendancesLog/approval", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendanceLogsApproval(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useAttendanceLogLocationDetail({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["attendancesLog/location/detail", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendanceLogsLocation(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export function useAttendanceLogAddress({ payload = {} }, options = {}) {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useQuery(
    ["attendanceLog/address", payload],
    async () => {
      let response;
      try {
        const {
          data: { data },
        } = await api.getAttendanceLogsAddress(payload);
        response = data;
      } catch (error) {
        throw new Error("Failed to load data from server!");
      }
      return response;
    },
    {
      onError: (error) =>
        message.error(t("error.failed_to_load_data_from_server")),
      ...options,
    }
  );
}

export const useApproveAttendanceLogs = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.approveAttendanceLog(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};

export const useRejectAttendanceLogs = () => {
  const { t } = useTranslation();
  const { message } = App.useApp();

  return useMutation((payload) => api.rejectAttendanceLog(payload), {
    onSuccess: ({ data }) => {
      if (data?.success) {
        message.success(data?.message);
      } else {
        message.error(data?.message);
      }
    },
    onError: (error) => message.error(t("error.failed_save_data_to_server")),
  });
};
